var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "appLayout",
      attrs: {
        page: "/dashboard",
        pageTitle: "Time Clock",
        backLink: "/dashboard/reports",
        hasFab: "",
      },
      on: {
        fabAction: function ($event) {
          _vm.showTimeClockForm = true
        },
      },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c("Stats", { staticClass: "pb-3", attrs: { stats: _vm.stats } }),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c("ReportHeader", {
                    attrs: {
                      filter: "",
                      legacyDate: _vm.payDay,
                      dateRange: _vm.dateRange,
                      rangeOptions: {
                        interval:
                          _vm.$page.props.auth.user.selected_location[
                            "pay_int"
                          ],
                        frequency:
                          _vm.$page.props.auth.user.selected_location[
                            "pay_freq"
                          ],
                      },
                      subtitle: "Time clock report by Pay Period",
                      reportUrl: "/dashboard/reports/time-clock/",
                    },
                    on: {
                      search: function ($event) {
                        _vm.search = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "extendedSubtitle",
                        fn: function () {
                          return [
                            _vm.isProcessed
                              ? _c(
                                  "v-list-item-subtitle",
                                  {
                                    staticClass: "font-bold error--text",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          left: "",
                                          small: "",
                                          color: "error",
                                        },
                                      },
                                      [_vm._v("flag")]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        `Processed on ${_vm.globalMomentFullDateAtTime(
                                          _vm.processed_at
                                        )}`
                                      )
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "filterItem",
                        fn: function () {
                          return [
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-list-item",
                                  { staticClass: "flex justify-center pt-1" },
                                  [
                                    _c("v-switch", {
                                      staticClass: "mt-0",
                                      attrs: {
                                        dense: "",
                                        label: `Group by Employee`,
                                        "hide-details": "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.groupByStaff
                                            ? (_vm.groupByStaff = null)
                                            : (_vm.groupByStaff = "staff_id")
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("v-data-table", {
                    ref: "table",
                    staticClass: "cursor-pointer table-nowrap",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.report,
                      search: _vm.search,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                      "item-key": "time_clock_id",
                      "group-by": _vm.groupByStaff,
                    },
                    on: {
                      "click:row": function ($event) {
                        return _vm.editEntry($event)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `group.header`,
                          fn: function ({ items, isOpen, toggle }) {
                            return [
                              _c(
                                "th",
                                { attrs: { colspan: _vm.headers.length } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex font-weight-regular" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-col align-self-center mr-2",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { on: { click: toggle } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  isOpen ? "remove" : "add"
                                                ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("SoliListAvatar", {
                                        attrs: {
                                          avatar:
                                            items[0].user.profile_photo_url,
                                          title: items[0].user.name,
                                          subtitle: items[0].user.email,
                                          href: `/profile/${items[0].user.id}/manage`,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `group.summary`,
                          fn: function ({ items }) {
                            return [
                              _c(
                                "div",
                                { attrs: { colspan: _vm.headers.length } },
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "font-weight-black soli-grey",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    `Total Hours: ${items
                                                      .map((e) =>
                                                        Number(e.duration)
                                                      )
                                                      .reduce((a, b) => a + b)}`
                                                  )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.user.name`,
                          fn: function ({ item }) {
                            return [
                              !_vm.groupByStaff
                                ? _c("SoliListAvatar", {
                                    attrs: {
                                      avatar: item.user.profile_photo_url,
                                      title: item.user.name,
                                      subtitle: item.user.email,
                                      href: `/profile/${item.staff_id}/manage`,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: `item.starts_at`,
                          fn: function ({ item }) {
                            return [
                              _c("div", { staticClass: "soli-grey" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.globalMomentFullDateAtTime(
                                        item.starts_at
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: `item.ends_at`,
                          fn: function ({ item }) {
                            return [
                              _c("div", { staticClass: "soli-grey" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      item.ends_at
                                        ? _vm.globalMomentFullDateAtTime(
                                            item.ends_at
                                          )
                                        : null
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: `item.rate_amount`,
                          fn: function ({ item }) {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    `${_vm.formatCurrency(
                                      item.rate_amount
                                    )}/hour`
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showTimeClockForm
        ? _c("SoliForm", {
            ref: "form",
            attrs: {
              title: `${_vm.form.id ? "Edit" : "New"} Time Clock Entry`,
              icon: "save",
              persistent: "",
              loadingProp: _vm.form.processing,
              text: "Save",
              saveChanges: _vm.valid,
            },
            on: {
              input: function ($event) {
                _vm.valid = $event
              },
              submit: function ($event) {
                return _vm.submitTimeClock()
              },
              reset: function ($event) {
                return _vm.resetTimeClock()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-4" },
                        [
                          _c("SoliStaff", {
                            attrs: {
                              disabled: _vm.editing,
                              rules: _vm.rules.select,
                              autocomplete: "",
                              rateOnly: "",
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.form.user,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "user", $$v)
                              },
                              expression: "form.user",
                            },
                          }),
                          _vm._v(" "),
                          _vm.form.user
                            ? _c("StaffPayRatesSelect", {
                                key: _vm.form.user.id,
                                attrs: {
                                  end: _vm
                                    .moment(
                                      new Date(
                                        `${_vm.form.endDate} ${_vm.form.endTime}`
                                      )
                                    )
                                    .toISOString(),
                                  user: _vm.form.user,
                                  rules: _vm.rules.select,
                                },
                                model: {
                                  value: _vm.form.role,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "role", $$v)
                                  },
                                  expression: "form.role",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("SoliDate", {
                            attrs: {
                              label: "Start Date",
                              noLimit: "",
                              min: _vm.editing
                                ? new Date(_vm.dateRange[0]).toISOString()
                                : null,
                              error: _vm.errors.starts_at,
                              rules: _vm.rules.input,
                              "hide-details": "auto",
                            },
                            on: {
                              input: function ($event) {
                                _vm.form.endDate = _vm.form.startDate
                              },
                            },
                            model: {
                              value: _vm.form.startDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "startDate", $$v)
                              },
                              expression: "form.startDate",
                            },
                          }),
                          _vm._v(" "),
                          _c("SoliTime", {
                            attrs: {
                              error: _vm.errors.starts_at,
                              rules: _vm.rules.input,
                              allowAll: "",
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.form.startTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "startTime", $$v)
                              },
                              expression: "form.startTime",
                            },
                          }),
                          _vm._v(" "),
                          _c("SoliDate", {
                            attrs: {
                              label: "End Date",
                              noLimit: "",
                              error: _vm.errors.ends_at,
                              rules: _vm.form.endTime ? _vm.rules.input : [],
                              min: new Date(_vm.form.startDate).toISOString(),
                              max: _vm.editing
                                ? new Date(_vm.dateRange[1]).toISOString()
                                : null,
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.form.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "endDate", $$v)
                              },
                              expression: "form.endDate",
                            },
                          }),
                          _vm._v(" "),
                          _c("SoliTime", {
                            attrs: {
                              label: "End Time",
                              icon: "timer_off",
                              error: _vm.errors.ends_at,
                              rules: _vm.endRule,
                              allowAll: "",
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.form.endTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "endTime", $$v)
                              },
                              expression: "form.endTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "cancelBtn",
                  fn: function (attrs) {
                    return [
                      _vm.editing
                        ? _c(
                            "SoliBtn",
                            _vm._b(
                              {
                                staticClass: "mt-3",
                                attrs: {
                                  text: "Delete",
                                  icon: "delete",
                                  color: "soli-status-red",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.confirmDelete = true
                                  },
                                },
                              },
                              "SoliBtn",
                              attrs,
                              false
                            )
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              2286118015
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmDelete
        ? _c("SoliChoice", {
            attrs: {
              title: "Are you sure?",
              subtitle: `This will delete the following entry for ${_vm.form.user.name}`,
              button1: "Delete",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                return _vm.submitTimeClock(true)
              },
              option2: function ($event) {
                _vm.closeModal(() => (_vm.confirmDelete = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }